module.exports = __webpack_public_path__ + "img/trash.84b74f29.svg";